
import { Component, Prop, Vue } from "vue-property-decorator";
import CiCheckbox from "../forms/checkbox.vue";

@Component({
  name: "ci-ais-toggle",
  components: {
    CiCheckbox,
  },
})
export default class extends Vue {
  @Prop({ required: true }) public attribute!: string;
  @Prop({ default: "" }) public label!: string;
}
